import axios from "./axios";

export default {
    fetchPaymentMethod() {
        const options = {
            method: 'POST',
            url: '/innovacatalogmh/getformapagoold',
            headers: { 'content-type': 'application/json' },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    fetchPaymentsMethod(params) {
        const options = {
            method: 'GET',
            url: '/formapago',
            headers: { 'content-type': 'application/json' },
            params,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    addPaymentMethod(data) {
        const options = {
            method: "POST",
            url: "/formapago",
            headers: { "content-type": "application/json" },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    },
    deletePaymentMethod(id) {
        const options = {
            method: "DELETE",
            url: `/formapago/${id}`,
            headers: { "content-type": "application/json" },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    },
    updatePaymentMethod(id, data) {
        const options = {
            method: "PATCH",
            url: `/formapago`,
            headers: { "content-type": "application/json" },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    },
    toggleEnabledPaymentMethod(id) {
        const options = {
            method: "PATCH",
            url: `/formapago/${id}/toggle-enabled`,
            headers: { "content-type": "application/json" },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    },
}